import { generateItems } from 'domain/common';
import { Substrate } from 'domain/lib';

const { actions, selectors, reducer } = generateItems('Substrate', Substrate);

export { actions, selectors, reducer };
